import { fetchApi } from '@/config/api';
import type { LoginResponse } from '@/types';

// Connexion utilisateur
export async function loginUser(email: string, password: string, rememberMe = false): Promise<LoginResponse> {
  const query = `
    mutation Login($email: String!, $password: String!, $rememberMe: Boolean!) {
      login(email: $email, password: $password, rememberMe: $rememberMe) {
        user {
          id_vendeur
          email
          nomContact
          nomBoutique
          siret
          tva
          mel
        }
        message
      }
    }
  `;

const response = await fetchApi<LoginResponse>(
    query,
    { email, password, rememberMe },
    { skipAuthRedirect: true },
  );

return response;
}

// Demande de réinitialisation de mot de passe
export async function requestPasswordReset(email: string): Promise<{ requestPasswordReset: boolean }> {
  const query = `
    mutation RequestPasswordReset($email: String!) {
      requestPasswordReset(email: $email)
    }
  `;
  return fetchApi<{ requestPasswordReset: boolean }>(
    query,
    { email },
    { skipAuthRedirect: true },
  );
}

// Réinitialisation (changement) du mot de passe avec le token reçu par email
export async function resetPassword(token: string, newPassword: string): Promise<{ resetPassword: boolean }> {
  const query = `
    mutation ResetPassword($token: String!, $newPassword: String!) {
      resetPassword(token: $token, newPassword: $newPassword)
    }
  `;
  return fetchApi<{ resetPassword: boolean }>(
    query,
    { token, newPassword },
    { skipAuthRedirect: true },
  );
}
